<div class="charset-list" (click)="openDialog(type)">
  <div class="charset-content" [ngStyle]="rtlService.$isRTL.value ? {'flex-direction': 'row-reverse'} : {'flex-direction': 'row'}">
    <div class="charset-text-content">
      <div class="charset-title">
        <h4>
          <a>{{ transformName(type) }}</a>
        </h4>
      </div>

      <p>{{ "results.biomarkerCard.algorithmDetected" | translate }}</p>
      @if (type == "eye_analysis") { @if (data.score?.analysis?.length > 0 &&
      data.score.analysis[0].severity) {
      <ul class="charset-list-container">
        <li>
          <span class="number">{{
            data.score.analysis[0].parameters.length
          }}</span>
          {{ "results.biomarkerCard.biomarkerCategories" | translate }}
        </li>
        <li>
          <span class="number">{{
            data.score.analysis[0]?.parametersSum
          }}</span>
          {{ "results.biomarkerCard.parameters" | translate }}
        </li>
      </ul>
      } } @else { @if (data.score?.analysis?.length > 0 &&
      data.score.analysis[1].severity) {
      <ul class="charset-list-container">
        <li>
          <span class="number">{{
            data.score.analysis[1].parameters.length
          }}</span>
          {{ "results.biomarkerCard.biomarkerCategories" | translate }}
        </li>
        <li>
          <span class="number">{{
            data.score.analysis[1]?.parametersSum
          }}</span>
          {{ "results.biomarkerCard.parameters" | translate }}
        </li>
      </ul>
      } } @if (type == "eye_analysis") {
      <span class="charset-read-more">{{
        "results.biomarkerCard.viewFullEyeAnalysis" | translate
      }}</span>
      } @else {
      <span class="charset-read-more">{{
        "results.biomarkerCard.viewFullSkinAnalysis" | translate
      }}</span>
      }
    </div>

    <div
      class="charset-circle-wrapper"
      *ngIf="data.score?.analysis?.length > 0"
    >
      @if (type == "eye_analysis") { @if (data.score?.analysis[0]?.severity) {
      <div class="single-severity-circle">
        <svg viewBox="0 0 110 110" class="circular-progress">
          <circle
            cx="55"
            cy="55"
            r="42"
            fill="none"
            stroke="#f7edf5"
            stroke-width="13"
            class="progress-bg"
          />
          <circle
            cx="55"
            cy="55"
            r="42"
            fill="none"
            [style.stroke]="getSeverityColor(data.score.analysis[0].severity)"
            stroke-width="13"
            stroke-linecap="round"
            class="progress-bar"
            [style.stroke-dasharray]="263.89"
            [style.stroke-dashoffset]="
              getSeverityDashOffset(data.score.analysis[0].severity)
            "
          />
        </svg>
        <div class="severity-text">
          {{ getSeverityDisplayText(data.score.analysis[0].severity) }}
        </div>
      </div>
      } } @else { @if (data.score.analysis[1]?.severity) {
      <div class="single-severity-circle">
        <svg viewBox="0 0 110 110" class="circular-progress">
          <circle
            cx="55"
            cy="55"
            r="42"
            fill="none"
            stroke="#f7edf5"
            stroke-width="13"
            class="progress-bg"
          />
          <circle
            cx="55"
            cy="55"
            r="42"
            fill="none"
            [style.stroke]="getSeverityColor(data.score.analysis[1].severity)"
            stroke-width="13"
            stroke-linecap="round"
            class="progress-bar"
            [style.stroke-dasharray]="263.89"
            [style.stroke-dashoffset]="
              getSeverityDashOffset(data.score.analysis[1].severity)
            "
          />
        </svg>
        <div class="severity-text">
          {{ getSeverityDisplayText(data.score.analysis[1].severity) }}
        </div>
      </div>
      } }
    </div>
  </div>
</div>
